import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { Popper, Modal, Backdrop } from '@material-ui/core';
import PhoneAndroidTwoToneIcon from '@material-ui/icons/PhoneAndroidTwoTone';
import { addZoneBrowsingHistories } from "../../../../actions/ZoneAction";

class BrokerInfoParts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formatMessage: this.props.intl['formatMessage'],
            isShowPopoverFlag: false,
            anchorEl: null,
            isShowWechatModalFlag: false,
        }
    }

    _handleOpenPopover(e, isShow) {
        this.setState({ isShowPopoverFlag: isShow, anchorEl: e.target })
    }

    _handleOpenWechatModal(isShow) {
        if (isShow) {
            const zone = this.props.zone ? this.props.zone : {};

            this.props.dispatch(addZoneBrowsingHistories(zone.id))
        }
        this.setState({ isShowWechatModalFlag: isShow })
    }

    render() {
        const broker = this.props.broker ? this.props.broker : {};
        const zone = this.props.zone ? this.props.zone : {};

        let style = {};
        if (this.props.color) {
            style.backgroundColor = this.props.color;
        }
        let imgParam = "?x-oss-process=style/Image_crop_wh400";
        let brokerPhoto = "https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png";
        if (broker.photo && broker.photo !== "") {
            brokerPhoto = broker.photo   //+ imgParam
        }
        let qrCodeParam2 = "?x-oss-process=style/Image_450";
        let brokerQrCode = broker.contactQrCode + qrCodeParam2;
        // const isDouYin = navigator.userAgent.toLowerCase().includes('toutiaomicroapp');
        const isDouYin = true;
        return (<div>
            <div className="broker-info-box"
                onClick={(e) => this._handleOpenPopover(e, !this.state.isShowPopoverFlag)}>
                <img className="broker-info-photo" src={brokerPhoto} />
                <div className="broker-info-name">{broker.lastName + broker.firstName}</div>
                <div className="broker-info-contact">联系我</div>
            </div>
            <Popper
                className="broker-info-popover"
                open={this.state.isShowPopoverFlag}
                anchorEl={this.state.anchorEl}
                onClose={() => this._handleOpenPopover(false)}
                placement="bottom"

            >
                <div className="broker-info-popover-box">
                    <div className="show-icon"><a href={"tel:" + broker.privacyMobile}
                        onClick={() => {
                            this.props.dispatch(addZoneBrowsingHistories(zone.id))
                        }}>
                        <PhoneAndroidTwoToneIcon /></a></div>
                    {
                        !isDouYin && <div className="show-icon">
                            <div onClick={() => {
                                this._handleOpenPopover(false);
                                this._handleOpenWechatModal(!this.state.isShowWechatModalFlag)
                            }}>
                                <img src={require('../../../../../../images/detail/wechat.svg')} />
                            </div>
                        </div>
                    }
                </div>
            </Popper>
            {
                !isDouYin && <Modal
                    className="broker-qrcode-modal"
                    open={this.state.isShowWechatModalFlag}
                    onClose={() => this._handleOpenWechatModal(false)}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <div className="broker-qrcode-modal-paper">
                        <p className='message-main'>长按识别二维码</p>
                        <p className='message-sub'>添加我的企业微信呢</p>
                        <img src={require('../../../../../../images/qr_code.png')} />
                    </div>

                </Modal>
            }

        </div>

        );
    }
}

function mapStateToProps(store) {
    return {}
}

export default connect(mapStateToProps)(injectIntl(BrokerInfoParts));